import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';
import { getDocument } from '../config';
import { ExamI } from '../types';

export function useDocumentByIdEffect(type: string, id: string, initialState:ExamI | null  = null) {
  const [element, setElement] = useState<ExamI | null>(initialState);

  const {
    loading
  } = hooks.useEffectRequestCallback(
    useCallback(async (request: any) => {
      const {
        document = {}
      } = await request.exec(getDocument(type, id));
      document.filesReport = document.filesReport || [];
      setElement(document);
    }, [id, type])
  );

  return {
    loading,
    element
  };
}

export default useDocumentByIdEffect;
